module.exports = __webpack_public_path__ + "img/PrecisionRecallCurve.35b3304f.png";